import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import '../css/Result.css';
import translations from "../constants/translations";

const Result = () => {
    const [total, setTotal] = useState(null);
    const [name, setName] = useState('');
    const navigate = useNavigate();

    // Fetch results from localStorage when the page loads
    useEffect(() => {
        const storedTotal = localStorage.getItem('total');
        const storedName = localStorage.getItem('name');

        if (storedTotal && storedName) {
            setTotal(storedTotal);
            setName(storedName);
        } else {
            navigate('/');
        }
    }, [navigate]);

    const language = localStorage.getItem('language');
    const translatedText = language ? translations[language] : translations['marathi'];

    const monthlySavings = Number(total);
    const annualSavings = Math.round(monthlySavings * 12);
    const fiveYearSavings = Math.round(annualSavings * 5);

    const handleWhatsAppShare = () => {
        const shareText = translatedText.waShareText(annualSavings);
        const url = `https://wa.me/?text=${encodeURIComponent(shareText)}`;
        window.open(url, "_blank");
    };

    return (
        <div id="result-container">
            <div className="centered-image-container">
                <img
                    src="https://images.netaapp.in/2024-11-317/22/a7cb4b79-1018-421b-83d5-7174002cb4dd"
                    alt="Centered"
                    className="centered-image"
                />
                <div className="result-text">
                    {name && (
                        <div className="boxed-text">
                            <h1>
                                {translatedText.resultLabel(name)}
                            </h1>
                        </div>
                    )}

                    {/* Annual Savings */}
                    <div className="savings-text">
                        <h3 style={{
                            color: '#923EB7',
                            fontFamily: 'georgia, palatino, book antiqua, palatino linotype, serif',
                            fontWeight: 'bold'
                        }}>
                            {translatedText.annualLabel(annualSavings)}
                        </h3>

                        {/* 5-Year Savings */}
                        <h3 style={{
                            color: '#4FC462',
                            fontFamily: 'georgia, palatino, book antiqua, palatino linotype, serif',
                            fontWeight: 'bold'
                        }}>
                            {translatedText.halfDecLabel(fiveYearSavings)}
                        </h3>
                    </div>
                </div>
            </div>
            {/* Share Button */
            }
            <button onClick={handleWhatsAppShare} style={{
                backgroundColor: '#25D366',
                color: 'white',
                padding: '10px 20px',
                fontSize: '16px',
                borderRadius: '5px',
                border: 'none',
                cursor: 'pointer',
                marginTop: '20px'
            }}>
                {translatedText.whatsappShareButton}
            </button>
        </div>
    )
        ;
};

export default Result;
